/**
 * Sets the public path (used for dynamic imports)
 * based on the location of the adapt core script.
 */
var setPublicPath = function () {
    var mainTag = [].map
        .call(document.getElementsByTagName('script'), function (node) { return node; })
        .find(function (tag) { return tag.src.indexOf('adapt-') !== -1; });
    if (!mainTag) {
        __webpack_public_path__ = './';
        return;
    }
    var publicPath = mainTag.src.replace(/adapt-[^\/]+\.js.*$/, '');
    if (publicPath.match(/^https?:/)) {
        __webpack_public_path__ = publicPath;
    }
    else {
        __webpack_public_path__ = './';
    }
};
export default setPublicPath;
